import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { delay } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { ApiService } from 'src/app/Services/api.service';
import { OtherApiService } from 'src/app/Services/other.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-confirm-notification',
  templateUrl: './confirm-notification.component.html',
  changeDetection: ChangeDetectionStrategy.Default
})
export class ConfirmNotificationComponent implements OnInit {
  @ViewChild('okButton',{static:false}) okButton: ElementRef; 
  /**
         * Component constructor
         *
         * @param data: any
         */
  // result: Subject<boolean> = new Subject<boolean>();
  safeMessage: SafeHtml;
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,private service: OtherApiService,private renderer: Renderer2,private ref:ChangeDetectorRef, private snackBarRef: MatSnackBarRef<ConfirmNotificationComponent>, private sanitizer: DomSanitizer) { }

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  primaryColour :any;
  ngOnInit() {
    this.safeMessage = this.sanitizer.bypassSecurityTrustHtml(this.data.message);
    this.primaryColour = this.service.passColour()

    if (!this.data.showUndoButton || (this.data.undoButtonDuration >= this.data.duration)) {
      return;
    }

    this.delayForUndoButton(this.data.undoButtonDuration).subscribe(() => {
      this.data.showUndoButton = false;
    });


  }
ngAfterViewInit()
{
  this.data.okButtonLabel = this.data.okButtonLabel;
  this.data.cancelButtonLabel = this.data.cancelButtonLabel;
  setTimeout(() => {
    if (this.okButton) {
      this.okButton.nativeElement.focus();
    }
  }, 0);

  // Listen for the Enter key and trigger confirm() if focused
  this.renderer.listen(this.okButton.nativeElement, 'keydown', (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      this.confirm();
    }
  });
  this.ref.detectChanges()
}
  /*
   *	Returns delay
   *
   * @param timeToDelay: any
   */
  delayForUndoButton(timeToDelay) {
    return of('').pipe(delay(timeToDelay));
  }

  confirm(): void {
    this.data.result.next(true);
    this.snackBarRef.dismiss();
  }

  cancel(): void {
    this.data.result.next(false);
    this.snackBarRef.dismiss();
  }
}
